import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import Routes from "./routes";
import { AppProvider } from "./context/AppContext";
import { CartProvider } from "./context/CartContext";
import { I18nProvider } from "./i18n";
import "./assets/css/bootstrap.css";
import "./assets/css/crm.css";

// เลื่อนหน้าขึ้นบนสุดทุกครั้งที่เปลี่ยน route
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <I18nProvider>
      <AppProvider>
        <CartProvider>
          <ScrollToTop />
          <Routes />
        </CartProvider>
      </AppProvider>
    </I18nProvider>
  </BrowserRouter>
);
